<template>
  <div>
    <div
      class="nav__bg"
      :class="{'nav__bg--active': active}"
      @click="hideNav"
    ></div>

    <nav class="nav" :class="{'nav--active': active, 'nav--hidden': !isHidden}">
      <div class="nav__header">
        <img v-if="isProduction" src="@/assets/toro.png" alt="Toro" class="nav__img">
        <img v-else src="@/assets/toro-canary.png" alt="Toro" class="nav__img">
        <hr>
      </div>
      <div class="nav__body">
        <ul class="nav__list">
          <li class="nav__link">
            <router-link @click.native="hideNav" to="/docs/" exact ><i class="fas fa-file-signature"></i> Wszystkie dokumenty</router-link>
          </li>
          <li class="nav__link">
            <router-link @click.native="hideNav" to="/docs/wychodzące" exact ><i class="fas fa-file-export"></i> Dokumenty wychodzące</router-link>
          </li>
          <li class="nav__link">
            <router-link @click.native="hideNav" to="/docs/przychodzące" exact ><i class="fas fa-file-import"></i> Dokumenty przychodzące</router-link>
          </li>
        </ul>
        <hr>
        <ul class="nav__list">
          <li class="nav__link">
            <router-link @click.native="hideNav" to="/docs/faktury" exact><i class="fas fa-file-invoice-dollar"></i> Faktury</router-link>
          </li>
          <li class="nav__link">
            <router-link @click.native="hideNav" to="/docs/faktury-wychodzące"><i class="fas fa-file-export"></i> Faktury wychodzące</router-link>
          </li>
          <li class="nav__link">
            <router-link @click.native="hideNav" to="/docs/faktury-przychodzące"><i class="fas fa-file-import"></i> Faktury przychodzące</router-link>
          </li>
        </ul>
        <hr>
        <ul class="nav__list">
          <li class="nav__link">
            <router-link @click.native="hideNav" to="/docs/magazyn" exact><i class="fas fa-boxes"></i> Dokumenty magazynowe</router-link>
          </li>
          <li class="nav__link">
            <router-link @click.native="hideNav" to="/docs/przyjęcia" exact><i class="fas fa-file-export"></i> Przyjęcia (Pz / Pw)</router-link>
          </li>
          <li class="nav__link">
            <router-link @click.native="hideNav" to="/docs/wydania" exact><i class="fas fa-file-import"></i> Wydania (Wz / Rw)</router-link>
          </li>
        </ul>
        <hr>
        <ul class="nav__list">
          <li class="nav__link">
            <router-link @click.native="hideNav" to="/docs/inne"><i class="fas fa-file-alt"></i> Inne dokumenty</router-link>
          </li>
          <li class="nav__link">
            <router-link @click.native="hideNav" to="/docs/kosz"><i class="fas fa-trash"></i> Kosz</router-link>
          </li>
        </ul>

        <hr style="margin-top: auto">
        <ul class="nav__list">
          <li class="nav__link">
            <router-link @click.native="hideNav" to="/reports"><i class="fas fa-chart-area"></i></i> Raporty</router-link>
          </li>
          <li class="nav__link">
            <router-link @click.native="hideNav" to="/contractors"><i class="fas fa-briefcase"></i> Kontrahenci</router-link>
          </li>
          <li class="nav__link">
            <router-link @click.native="hideNav" to="/organization"><i class="fas fa-users"></i> Organizacja</router-link>
          </li>
          <li class="nav__link">
            <router-link @click.native="hideNav" to="/settings"><i class="fas fa-cog"></i> Ustawienia</router-link>
          </li>
        </ul>
        <hr>

        <div class="nav__user">
          <app-select
            v-model="activeOrganization"
            noBorder
            placeholder="Organizacja"
          >
            <option :value="org.id" v-for="org in organizationsList" :key="org.id">{{ org.name }}</option>
            <option value="new">+ nowa organizacja</option>
          </app-select>
          <span>{{ user.name }}</span>
        </div>

        <div class="nav__footer">
          <button class="btn btn--small" @click="logout">Wyloguj się</button>
          <small>Toro 0.2.5 by <a href="https://heseya.com" target="_blank">Heseya</a></small>
        </div>
      </div>

    </nav>
  </div>
</template>

<script>
import Select from '@/components/Select.vue'
import router from "@/router";

export default {
  name: 'app-nav',
  data() {
    return {
      activeOrganization: this.$store.state.user.activeOrganization,
      organizationsList: this.$store.state.user.user.organizations
    }
  },
  computed: {
    active() {
      return this.$store.state.navActive
    },
    isHidden() {
      return !this.$route.meta.hiddenNav
    },
    user() {
      return this.$store.state.user.user
    },
    isProduction() {
      return location.origin === 'https://toro.heseya.com'
    }
  },
  methods: {
    hideNav() {
      this.$store.commit('hideNav')
    },
    logout() {
      this.$store.dispatch('user/logout')
    }
  },
  watch: {
    activeOrganization() {
      // przejście do ekranu dodawania ogranizacji jeśli wybierze się '+' w select
      if (this.activeOrganization === 'new') {
        this.$nextTick(() => {
          this.activeOrganization = this.$store.state.user.activeOrganization;
        });
        router.push('/join-organization')
        this.$store.commit('hideNav')
        return
      }

      this.$store.dispatch('user/setActiveOrganization', this.activeOrganization)
      console.log("TCL: setActiveOrganization -> this.activeOrganization", this.activeOrganization)

      const name = this.$route.name
      if(name == 'edit-invoice' || name == 'doc')
        this.$router.push('/docs')
    }
  },
  mounted() {
    this.$store.subscribe((mutation, state) => {
      if(mutation.type == 'user/setActiveOrganization')
        this.activeOrganization = state.user.activeOrganization

      if(mutation.type == 'user/updateUser')
        this.organizationsList = state.user.user.organizations
    })
  },
  components: {
    appSelect: Select
  }
}
</script>

<style lang="scss" scoped>
.nav {
  position: fixed;
  top: 0;
  left: -100vw;
  height: 100vh;
  width: 80%;
  box-shadow: 3px 3px 8px rgba(#000000, 0.16);
  background-color: #fff;
  display: flex;
  flex-direction: column;
  z-index: 200;
  transition: 0.3s;

  @media screen and (min-width: #{$media-900}) {
    left: 0;
    width: 300px;

    &--hidden {
      left: -100%;
    }
  }

  &--active {
    left: 0;
  }

  &__bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: #333;
    z-index: 199;
    opacity: 0;
    visibility: hidden;
    transition: 0.3s;

    &--active {
      opacity: 0.7;
      visibility: visible
    }
  }

  &__img {
    height: 32px;
    width: auto;
    object-fit: contain;
    object-position: left;
    margin: 20px 16px;
    margin-bottom: 14px;
  }

  &__header {
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 300;
    background: white;
  }

  &__body {
    overflow: auto;
    margin-top: 71px;
  }

  hr {
    all: unset;
    display: block;
    border-bottom: solid 1px #e8e8e8;
    width: 100%;
  }

  select {
    background-color: #fff;
  }

  &__list {
    list-style: none;
    margin: 8px 0;
    padding: 0;
  }

  &__link--active a,
  a.router-link-active {
    color: $primaryColor;
    // background-color: rgba($primaryColor, 0.3);
    background: linear-gradient(to right, rgba($primaryColor, 0.3), #fff, #fff, #fff);
  }

  &__link a {
    display: block;
    width: 90%;
    padding: 8px;
    margin: 2px 0;
    padding-left: 16px;
    background-color: transparent;
    border-top-right-radius: 16px;
    border-bottom-right-radius: 16px;
    font-size: 16px;
    color: #666;
    text-decoration: none;

    &:hover {
      color: $primaryColor;
      // background-color: rgba($primaryColor, 0.3);
      background: linear-gradient(to right, rgba($primaryColor, 0.3), #fff, #fff);
    }

    i {
      margin-right: 16px;
      width: 16px;
      text-align: center;
    }
  }

  &__user {
    padding: 12px 12px 6px 12px;

    .select {
      margin-bottom: 0;
    }

    span {
      font-size: 0.7em;
      color: #888;
      padding-left: 4px;
    }
  }

  &__footer {
    margin: 6px auto;
    text-align: center;
    width: 70%;
    margin-top: 24px;

    .btn {
      width: 100%;
    }

    small {
      color: $primaryColor;
      font-size: 12px;
    }
  }
}
</style>
